import script from "./ShareholderAccountTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShareholderAccountTab.vue?vue&type=script&setup=true&lang=ts"

import "./ShareholderAccountTab.vue?vue&type=style&index=0&id=29490ac6&scoped=true&lang=postcss"

import exportComponent from "/var/www/rentasdhelos.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29490ac6"]])

export default __exports__